import CatalogConfiguratorStore from '../../_flux/stores/catalog_configurator_store';
import {
    showFirstLayerAction,
    hideInfoLayerAction,
} from '../../_flux/actions/catalog_configurator_actions';

export function onBackClick() {
    const state = CatalogConfiguratorStore.getState();
    if (state.infoLayerVisible) {
        hideInfoLayerAction();
    } else {
        showFirstLayerAction();
    }
}
